export default {
  dontShowAgainZelle: false,
  viewCount: 0,
};
